//@flow

export const FirstPageExperiment = Object.freeze({
  'Old': 'old',
  'New': 'new'
})
